import React from 'react';
import Button from '@mui/material/Button';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import variables from '../../utils/variables';
import { appsLinks } from '../../config';
import './index.css';
import NucleusIcon from '../../assets/apps/nucleus.svg';
import InSyncIcon from '../../assets/apps/insync.svg';
import TvIcon from '../../assets/apps/tv.svg';

const AppsEcosystem = (props) => {
    const handleRedirect = (value) => {
        window.open(value, '_self');
    };

    return (
        <div className="app_ecosystem">
            <p>{variables[props.lang].omniflix_ecosystem}</p>
            <div className="app_links">
                <Button onClick={() => handleRedirect(appsLinks.NUCLEUS)}>
                    <img alt="market" src={NucleusIcon}/>
                </Button>
                <Button onClick={() => handleRedirect(appsLinks.IN_SYNC)}>
                    <img alt="" src={InSyncIcon}/>
                </Button>
                <Button onClick={() => handleRedirect(appsLinks.TV)}>
                    <img alt="tv" src={TvIcon}/>
                </Button>
            </div>
        </div>
    );
};

AppsEcosystem.propTypes = {
    lang: PropTypes.string.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
    };
};

export default connect(stateToProps)(AppsEcosystem);
